import styled from "styled-components";
import Colors from "../../constants/Colors";

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;

  background: linear-gradient(135deg, #062b50 0%, #0A5190 45%, #0d68b8 100%);
  position: relative;
  overflow: hidden;

  /* Ambient Glass Orbs in Background (Keep glowing effect user loved) */
  &::before {
    content: "";
    position: absolute;
    top: -15%;
    left: -10%;
    width: 50vw;
    height: 50vw;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(96, 165, 250, 0.25) 0%, rgba(10, 81, 144, 0) 70%);
    backdrop-filter: blur(40px);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -15%;
    right: -10%;
    width: 50vw;
    height: 50vw;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 131, 16, 0.18) 0%, rgba(10, 81, 144, 0) 70%);
    backdrop-filter: blur(40px);
    pointer-events: none;
  }
`;

export const LoginContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  min-height: 600px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.32);
  background-color: #ffffff;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 860px) {
    flex-direction: column;
    max-width: 480px;
    min-height: auto;
  }
`;

export const LoginFormWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 44px;
  box-sizing: border-box;

  @media screen and (max-width: 520px) {
    padding: 32px 24px;
  }
`;

export const BrandPanel = styled.div`
  width: 420px;
  background: linear-gradient(145deg, #f0f6ff 0%, #e6effa 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  border-left: 1px solid rgba(10, 81, 144, 0.08);
  position: relative;

  @media screen and (max-width: 860px) {
    display: none;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 26px;
  line-height: 34px;
  font-family: "Inter", sans-serif;
  color: #1f2937;
  margin: 0 0 8px 0;
  text-align: left;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #6b7280;
  font-family: "Inter", sans-serif;
  margin: 0 0 28px 0;
  text-align: left;
`;

export const LoginFormContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;

export const LoginFieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const HelpIcon = styled.img`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const InputLogin = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 44px 0 46px;
  font-family: "Inter", sans-serif;
  font-size: 14.5px;
  color: #1f2937;
  border: 1.5px solid #e5e7eb;
  border-radius: 12px;
  background-color: #f9fafb;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: ${Colors.SPM600};
    background-color: #ffffff;
    box-shadow: 0 0 0 4px rgba(10, 81, 144, 0.12);
  }
`;

export const InputIconLeft = styled.div`
  position: absolute;
  left: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  pointer-events: none;
`;

export const InputIconRight = styled.div`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
`;

export const LabelCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  font-size: 13.5px;
  font-family: "Inter", sans-serif;
  color: #4b5563;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: ${Colors.SPM600};
    border-radius: 4px;
    cursor: pointer;
  }
`;

export const LoginSubmitBtn = styled.button<{ $loading?: boolean }>`
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  background: linear-gradient(135deg, #0A5190 0%, #0F68B8 100%);
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(10, 81, 144, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(10, 81, 144, 0.4);
    background: linear-gradient(135deg, #084378 0%, #0D5AA0 100%);
  }

  &:active {
    transform: translateY(0);
  }

  opacity: ${({ $loading }) => ($loading ? 0.75 : 1)};
  pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};
`;

export const Spinner = styled.div`
  width: 22px;
  height: 22px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;